import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import UserFaqBase from './user-faq.base';

const UserFaqDesktop: React.FC<{ title: string; }> = ({ title }) => (
    <StaticLayoutDesktop title={title}>
        <UserFaqBase />
    </StaticLayoutDesktop>
);

export default withHydrate(UserFaqDesktop, { root: '#root' }, 'views/pages/static/user-faq/user-faq.desktop');
